import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ResultOfDebtorIndex, AvailablePowerOfAttorney} from '../../../api/client';
import { actionCreators as ConversationSupervisorStoreActionCreators } from '../../../store/ConversationSupervisorStore';
import { actionCreators as DebtorClaimsStoreActionCreators } from '../../../store/DebtorClaimsStore';
import { actionCreators as DebtorSearchStoreActionCreators } from '../../../store/DebtorSearchStore';
import { actionCreators as PowerOfAttorneyStoreActionCreators } from '../../../store/PowerOfAttorneyStore';
import CircularProgress from '@mui/material/CircularProgress';
import DebtorSearchResultItem from '../../../components/debtorSearch/presentation/DebtorSearchResultItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'; 
import { isEqual } from 'lodash';

interface PropsFromState {
  criteria: string;
  isSearching: boolean;
  results?: ResultOfDebtorIndex[];
  powerOfAttorneyByIds: { [key: string]: AvailablePowerOfAttorney[] };
}

interface PropsFromDispatch {
  resetConversationSupervisor: typeof ConversationSupervisorStoreActionCreators.resetConversationSupervisor;
  resetDebtorClaims: typeof DebtorClaimsStoreActionCreators.resetDebtorClaims;
  selectDebtor: typeof DebtorSearchStoreActionCreators.selectDebtor;
  selectCaseNumber: typeof DebtorSearchStoreActionCreators.selectCaseNumber;
  getPowerOfAttorneysByDebtorIds: typeof PowerOfAttorneyStoreActionCreators.getPowerOfAttorneysByDebtorIds;
}

type ComponentProps = PropsFromState & PropsFromDispatch;

class DebtorSearchResults extends React.Component<ComponentProps> {
  
  getDebtorIds = (results?: ResultOfDebtorIndex[]): string[] => {
    const debtorIds: string[] = [];
    results?.forEach((item) => {
      if (item.document?.id) {
        debtorIds.push(item.document.id);
      }
    });
    return debtorIds;
  };

  componentDidMount(): void {
    const debtorIds = this.getDebtorIds(this.props.results);
    if (debtorIds.length > 0) {
      this.props.getPowerOfAttorneysByDebtorIds(debtorIds);
    }
  }

  componentDidUpdate(prevProps: ComponentProps) {
    if (!isEqual(prevProps.results, this.props.results)) {
      const debtorIds = this.getDebtorIds(this.props.results);
      if (debtorIds.length > 0) {
        this.props.getPowerOfAttorneysByDebtorIds(debtorIds);
      }
    }
  }

  public render() {
    const noResults = !!this.props.criteria && (!this.props.results || this.props.results!.length < 1);

    return (
      <Box>
        {this.props.isSearching &&
          <Box sx={{
            width: '75px',
            margin: '0 auto',
          }}>
            <CircularProgress size={75} />
          </Box>
        }

        {!this.props.isSearching && noResults &&
          <Box sx={{
            display: 'flex',
          }}>
            <Typography variant="h5" sx={{
              margin: '0 auto'
            }}>Søk etter '{this.props.criteria}' ga ingen treff</Typography>
          </Box>
        }

        {!this.props.isSearching && !noResults &&
          <Box sx={{
            width: '95%',
            margin: '0 auto',
          }} data-id="searchResults">
            {this.props.results!.map((item, i) =>
              <DebtorSearchResultItem
                key={i}
                item={item}
                resetConversationSupervisor={this.props.resetConversationSupervisor}
                resetDebtorClaims={this.props.resetDebtorClaims}
                selectDebtor={this.props.selectDebtor}
                selectCaseNumber={this.props.selectCaseNumber}
              />)
            }
          </Box>
        }
      </Box>
    );
  }
}

const mapStateToProps = ({ debtorSearch, powerOfAttorney }: ApplicationState): PropsFromState => ({
  criteria: debtorSearch.criteria,
  isSearching: debtorSearch.isSearching,
  results: debtorSearch.results ? debtorSearch.results.results : [],
  powerOfAttorneyByIds: powerOfAttorney.powerOfAttorneyByIds
});

const mapDispatchToProps: PropsFromDispatch = {
  resetConversationSupervisor: ConversationSupervisorStoreActionCreators.resetConversationSupervisor,
  resetDebtorClaims: DebtorClaimsStoreActionCreators.resetDebtorClaims,
  selectDebtor: DebtorSearchStoreActionCreators.selectDebtor,
  selectCaseNumber: DebtorSearchStoreActionCreators.selectCaseNumber,
  getPowerOfAttorneysByDebtorIds: PowerOfAttorneyStoreActionCreators.getPowerOfAttorneysByDebtorIds
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(DebtorSearchResults);
